export enum LocalStoreKeys {
    uuid = 'uuid',
    currentUser = 'currentUser',
    currentUserRegistry = 'currentUserRegistry',
    applicationUser = 'applicationUser',
    perfis = 'perfis',
    currentOrder = 'currentOrder',
    currentPedidoInfo = 'currentPedidoInfo',
    currentPedidoAlerta = 'currentPedidoAlerta',
    parametros = 'parametros',
    loginRequest = 'loginRequest',
    passoAtual = 'passoAtual',
    filtroColaborador = 'filtroColaborador',
    gatewayUser = 'gatewayUser',
    currentPurchase = 'currentPurchase',
    colaboradoesArquivoList = 'colaboradoesArquivoList',
    grupoRascunho = 'grupoRascunho',
    possuiConta = 'possuiConta',
    grupo = 'grupo',
    tutorial = 'tutorial',
    passos = 'passos',
    currentPurchaseInfo = 'currentPurchaseInfo',
    currentPurchasePayment = 'currentPurchasePayment',
    currentBalance = 'currentBalance',
    currentAccountBalance = 'currentAccountBalance'
}
